import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { JobMatchAnalysisView } from './job-match/JobMatchAnalysisView';
import { JobMatchScore } from './job-match/JobMatchScore';
import { JobAnalysisProps, JobAnalysisScore } from './job-match/jobMatchTypes';
import { useJobMatchAnalysis } from './job-match/useJobMatchAnalysis';

const JobMatchAnalysis: React.FC<JobAnalysisProps> = (props: JobAnalysisProps) => {
  const { job, variant = 'normal' } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const analysis = useJobMatchAnalysis(props);

  return (
    <JobMatchAnalysisView
      job={job}
      variant={variant}
      isMobile={isMobile}
      dividerColor={theme.palette.divider}
      {...analysis}
    />
  );
};

export type { JobAnalysisScore };
export { JobMatchAnalysis, JobMatchScore };
